import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class FeedbackCardsRules extends Component {
	
	render() {

		const style = {
			margin: {
				marginTop: "20px"
			}
		};

		return (
			<section>
				<div>
					<div className='container'>
						<Typography variant="headline" style={{ fontSize: "35px" }}>
							Feedback Cards Rules
						</Typography>
						<Typography style={style.margin} component="p">
                        This section is going to give you two <br />
                        character-wise Feedback Cards,<br />
                        you can choose the one fits you better -<br />
                        or you think boths cards describe you well.<br />
                        We present you 8 sets of a pair of Feedback Cards<br />
						along with a "both" option.
							
						</Typography>

						<Link to={'/quiz/23'} >
							<Button variant="raised" style={style.margin} color="primary">
								Start Feedback Cards
							</Button>
						</Link>
					</div>
				</div>
			</section>
		);
	}
}

export default FeedbackCardsRules;


// WEBPACK FOOTER //
// ./src/views/FeedbackCardsRulesView.jsx